import React, { useEffect, useState, useRef } from "react";
import Helper from "../../../core/helper/helper";
import LocalData from "../../../core/localData";
import { addItemToUser, getItemList } from "../../../api/routes/api.route";
import Cookies from 'universal-cookie';
import { GENERAL } from "../../../assets/images/images";
import ScheduleAddEquipment from "./ScheduleAddEquipment";
import Labels from "../../../variables/labels";
/**
 * @param {Object} props
 * @param {boolean} props.stepActive
 * @param {string} props.itemInfoTitle
 * @param {string} props.itemInfoSubtitle
 * @param {Funtion} props.onStepActive
 * @param {string} props.itemInfoId
 * @returns
 */
const ScheduleTopInformation = (props) => {
  const cookies = new Cookies();
  const [stepActive, setStepActive] = useState(props.stepActive);
  const [hasServiceFixedDate, setHasServiceFixedDate] = useState(props.hasServiceFixedDate);
  const [equipmentsData, setEquipmentsData] = useState([]);
  const [selectedEquipment, setSelectedEquipment] = useState(null);
  const [showEquipmentList, setShowEquipmentList] = useState(true);
  const [addEquipment, setAddEquipment] = useState(false);
  const [addItemFields, setAddItemFields] = useState(props.tempEquipData || Helper.itemFieldsToAdd());
  const [disabledAddItemButton, setDisabledAddItemButton] = useState(!Helper.hasValidFields(addItemFields));
  const scheduleAddEquipmentRef = useRef(null);

  useEffect(() => {
    props.setDisableAddingEquip(addEquipment);
  // eslint-disable-next-line
  }, [addEquipment]);

  useEffect(() => {
    if (!showEquipmentList) {
      resetAddItemFields();
    }
  }, [showEquipmentList]);

  useEffect(() => {
    setHasServiceFixedDate(props.hasServiceFixedDate);
  }, [props.hasServiceFixedDate]);

  useEffect(() => {
    setStepActive(props.stepActive);
  }, [props.stepActive]);

  useEffect(() => {
    callGetItemsApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetAddItemFields = () => {
    //setAddItemFields(Helper.itemFieldsToAdd());
    if (scheduleAddEquipmentRef.current) {
      scheduleAddEquipmentRef.current.resetState();
    }
    setAddEquipment(false);
  };

  const addItem = async (event) => {
    const fields = event;
    const newItem = Helper.buildEquipmentSpecsBody(fields);
    if (Helper.isLiteVersion()) {
    } else {
      addItemToUser(cookies.get("sessionToken"), newItem).then((value) => {
        // setLoadingStateAddItem(false);
        if (value) {
          if (value.code) {
            if (value.code === 401) {
              Helper.callLogError("401 addItemToUser ");
              return;
            }
            if (value.code === 409) {
            } else if (value.code === 429) {
              props.renderInformationModal(Labels.registedErrorTitle, value.message);
            } else {
            }
          } else {
            callGetItemsApi();
          }
        } else {
        }
        setShowEquipmentList(false);
      });
    }
  };

  const callGetItemsApi = async () => {
    const support_equipment = LocalData.configData?.support_equipment;
    if (support_equipment) {
      if (LocalData.terms_accepted) {
        try {
          const value = await getItemList(cookies.get("sessionToken"));
          if (value && !value.code && value.items && value.items?.length > 0) {
            LocalData.equipmentsData = value.items;
            setEquipmentsData(value.items);
            setSelectedEquipment(value.items[0]); // Seleciona o primeiro equipamento por padrão
            setShowEquipmentList(false);
            resetAddItemFields();
            if (props.handleItemSelected) props.handleItemSelected(value.items[0].id);
          } else {
          }
        } catch (error) {
          console.error("Failed to fetch item list", error);
        }
      }
    }
  };

  const handleSelectEquipment = (equipment) => {
    setSelectedEquipment(equipment);
    setShowEquipmentList(false);
    setAddEquipment(false);
    resetAddItemFields();
    if (props.handleItemSelected) props.handleItemSelected(equipment.id);
  };

  const handleAddEquipment = (inList) => {
    setAddEquipment(inList);
    //TODO: scroll id={equipListContainer} to bottom
    setTimeout(() => {
      const container = document.getElementById("equipListContainer");
      if (container) {
        container.scrollTo({ top: container.scrollHeight, behavior: "smooth" });
      }
    }, 300);
  };

  const renderEquipmentSelection = () => {
    if (equipmentsData.length === 0) return null;

    return (
      <>
        <div id="equipListContainer" className={`schedule-service-top-info-list-container ${showEquipmentList ? 'open' : ''}`}>
          {(!addEquipment && equipmentsData.length > 1 ) && equipmentsData.map((equipment) => (
            <div
              key={equipment.id}
              className={`schedule-service-top-info-container list ${selectedEquipment?.id === equipment.id ? 'selected' : ''}`}
              onClick={() => handleSelectEquipment(equipment)}
            >
              <div className='schedule-service-top-image-container'>
                <img
                  src={Helper.urlItemImage(equipment.image)}
                  alt="serviceImage"
                  className="schedule-service-top-image"
                  onError={(e) => { e.target.src = Helper.defaultImage(); e.target.onerror = null; }}
                />
              </div>
              <div className="schedule-service-top-info">
                <div className='schedule-service-top-title'>{equipment.title}</div>
                <div className='schedule-service-top-subtitle'>{equipment.subtitle}</div>
              </div>
            </div>
          ))}
          {!addEquipment && (
            <div
              className="cta-button-secondary m-2 w-100 d-flex justify-content-center align-items-center"
              style={{ maxWidth: "98%" }}
              role="button"
              onClick={() => handleAddEquipment(true)}
            >
              {`+ Adicionar ${Helper.itemPronoun4()} ${Helper.itemLabel()}`}
            </div>
          )}
          {addEquipment && (
            <>
              {renderAddEquipment(true)}
              <div className="d-flex px-2 w-100">
                <div
                  className="cta-button-secondary m-1 w-100 d-flex justify-content-center align-items-center"
                  style={{
                    maxWidth: "98%",
                  }}
                  role="button"
                  onClick={() => {
                    setShowEquipmentList(false);
                    resetAddItemFields();
                  }}
                >
                  {`Cancelar nov${Helper.itemPronoun1().toLowerCase()} ${Helper.itemLabel().toLowerCase()}`}
                </div>
                <div
                  className="cta-button-primary m-1 w-100 d-flex justify-content-center align-items-center"
                  style={{
                    maxWidth: "98%",
                    cursor: disabledAddItemButton ? "default" : "pointer",
                    opacity: disabledAddItemButton ? 0.6 : 1,
                  }}
                  role="button"
                  onClick={() => {
                    if (!disabledAddItemButton) {
                      addItem(addItemFields);
                    }
                  }}
                >
                  {`Guardar nov${Helper.itemPronoun1().toLowerCase()} ${Helper.itemLabel().toLowerCase()}`}
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  };

  const renderStepsContainer = () => {
    if (props.isLockedToStep3 || props.isLockedToStep2) return null;


    const steps = [1, 2, 3];

    const handleStepClick = (step) => {
      // Disable clicking on step 2 when hasServiceFixedDate (fixed date does not allow changing the date in step 2)
      if (hasServiceFixedDate && stepActive === 3 && step === 2) return;

      setStepActive(step);
      props.onStepActive(step);
    };

    return (
      <div className="steps-container mt-4">
        {steps.map((step, i) => (
          <div
            className={`step ${step === stepActive
                ? "active"
                : step > stepActive || (hasServiceFixedDate && stepActive === 3 && step === 2) 
                  || (props.isLockedToStep2 && step === 1) || (props.isLockedToStep3 && stepActive === 3 && step === 1)
                  ? "disabled"
                  : ""
              }`}
            role="button"
            key={i}
            onClick={() => {
              if (!(hasServiceFixedDate && stepActive === 3 && step === 2)
                && !(props.isLockedToStep2 && step === 1) && !(props.isLockedToStep3 && stepActive === 3 && step === 1)
              ) {
                handleStepClick(step);
              }
            }}
          >
            {step}
          </div>
        ))}
      </div>
    );
  };


  // const renderValue = (value, random) => {
  //   return (Helper.isLiteVersion() && !itemInfoId?.includes("int")) ? (
  //     <Fragment>
  //       <span>
  //         {(() => {
  //           const processedValue = Helper.printValue(value);
  //           if (processedValue.includes(" ") || processedValue.includes("-")) {
  //             return processedValue.split(" ")[0].split("-")[0];
  //           } else {
  //             return processedValue.slice(0, 2);
  //           }
  //         })()}
  //       </span>
  //       <span className='pixelized'>{random}</span>
  //     </Fragment>
  //   ) : (
  //     Helper.printValue(value)
  //   );
  // };

  const renderAddEquipment = (inList) => {
    const notLiteNoEquip = !Helper.isLiteVersion() && equipmentsData?.length === 0;
    return (
      <>
        <div className={`schedule-service-top-info-container add ${inList ? 'list' : ''} ${notLiteNoEquip ? 'notLiteNoEquip' : ''} `}>
          <div className="vehicle-title">
            {inList ?
              `Nov${Helper.itemPronoun1().toLowerCase()} ${Helper.itemLabel()}:` :
              `Introduza os dados ${Helper.itemPronoun5()} ${Helper.itemLabel().toLowerCase()} para Marcação`
            }
          </div>

          <ScheduleAddEquipment
            ref={scheduleAddEquipmentRef}
            defaultItem={addItemFields}
            onChange={(data) => {
              setDisabledAddItemButton(!Helper.hasValidFields(data));
              setAddItemFields(data);
              props.addTempEquipment(data);
            }}
          ></ScheduleAddEquipment>
        </div>
        {(Helper.isLiteVersion() && (!equipmentsData || equipmentsData?.length === 0)) && (
          <div
            className="schedule-service-top-select-equipment"
            
          >
            <span>
              <span
                style={{ textDecoration: 'underline', color: 'inherit', cursor: 'pointer'}}
                onClick={() => props.toLogin(true)}
              >
                Fazer login
              </span>{' '}
              para ver {Helper.itemPronoun1().toLowerCase()}s {Helper.itemPronoun6().toLowerCase()}s {Helper.itemLabel().toLowerCase()}s
            </span>
          </div>
        )}
      </>
    );
  }

  const renderTopDescription = () => {
    const support_equipment = LocalData.configData.support_equipment;
    if ((stepActive !== 3 && equipmentsData.length === 0) || (!support_equipment)) {
      return (
        <div className="schedule-service-description-container empty justify-content-center">
          <div className="service-description-text">Marcação</div>
        </div>
      );
    }

    if (stepActive === 3 && equipmentsData.length === 0) {
      const inList = false
      return (
        <>
          {renderAddEquipment(inList)}
        </>
      );
    }

    return (
      <>
        <div className='schedule-service-top-info-container' >
          <div className='schedule-service-top-image-container'>

            <img
              src={Helper.urlItemImage(selectedEquipment?.image)}
              alt="serviceImage"
              className="schedule-service-top-image"
              onError={(e) => { e.target.src = Helper.defaultImage(); e.target.onerror = null; }}
            />
          </div>
          <div className="schedule-service-top-info">
            <div className='schedule-service-top-title'>
              {selectedEquipment?.title}
            </div>
            <div className='schedule-service-top-subtitle'>
              {selectedEquipment?.subtitle}
            </div>
          </div>

        </div>

        <div className={`schedule-service-top-select-equipment button ${showEquipmentList ? 'open' : ''}`}
          onClick={() => setShowEquipmentList(!showEquipmentList)}>
          <span>{equipmentsData.length === 1 ? "Adicionar " : "Selecionar "} {Helper.itemPronoun3()} {Helper.itemLabel().toLowerCase()}  </span>
          <img src={showEquipmentList ? GENERAL.iconSmallArrowUp : GENERAL.iconSmallArrowDown} alt="arrow-down" style={{ marginLeft: "8px" }} />
        </div>

        {renderEquipmentSelection()}


      </>
    );
  };

  return (
    <div className="top-information-container mt-5">
      {renderTopDescription()}
      {renderStepsContainer()}
    </div>
  );
};

export default ScheduleTopInformation;
